// llm 플러그인 — 대화 1회 = 이용권 1장, 답은 스트림으로 (prd/119 Story 6, FR-011)
// 화면은 MVP API(`/api/llm/chat`)만 부른다. 그 서버가 이용권을 1장 차감한 뒤 공용 플랫폼의 LLM 창구로 중계한다.
// 모델 키는 어디에도 없다 — 화면이 보내는 것은 로그인 토큰과 메시지뿐이다.
//
// 이 플러그인은 견본이다. MVP 는 presentation/chat-widget.tsx 를 자기 대화 화면으로 바꾸고, 훅(composition/use-llm-chat.ts)은 그대로 쓴다.
// 이용권을 채우는 방법(결제·광고 보상)과 장수는 api/internal/entitlement/credits.go — 아래 README 「대화 이용권」
// 끄는 법: composition/plugin-config.ts 에 `llm: { enabled: false }`. 위젯만 끄고 훅·문구를 쓰려면 `llm: { params: { widget: false } }`
import { z } from 'zod';

import { definePlugin } from '../../composition/plugin-runtime';
import { chatWidget } from './presentation/chat-widget';

export default definePlugin({
  name: 'llm',
  version: '0.1.0',
  // 이용권은 로그인한 유저에게만 있다
  dependsOn: ['auth'],
  params: z.object({
    chatEndpoint: z.string().startsWith('/'),
    creditsEndpoint: z.string().startsWith('/'),
    /** 견본 대화 위젯을 홈에 그린다. 프리셋이 자기 대화 화면을 쓸 때 끈다 — 문구(402 안내 등)는 그대로 등록된다 (prd/123 T-04).
     *  실패 문구는 `t(chatErrorMessageKey(error, useAdRewardOn()))` 로 고른다 — 402 안내가 광고 보상 사용 여부를 따른다 */
    widget: z.boolean(),
  }),
  defaults: { params: { chatEndpoint: '/api/llm/chat', creditsEndpoint: '/api/credits', widget: true } },
  setup(ctx, params) {
    ctx.messages('ko', {
      label: '대화',
      balance: '남은 이용권',
      prompt: '메시지',
      send: '보내기',
      stop: '멈추기',
      'error.login_required': '로그인이 풀렸어요. 다시 로그인해 주세요',
      'error.credits_exhausted': '이용권을 다 썼어요. 결제하면 채워져요',
      // 광고 보상이 켜진 앱에서만 쓴다 (domain/chat.ts chatErrorMessageKey)
      'error.credits_exhausted_ad': '이용권을 다 썼어요. 결제하거나 광고를 보면 채워져요',
      'error.bad_request': '보낼 수 없는 메시지예요. 내용을 확인해 주세요',
      'error.unavailable': '지금은 대화할 수 없어요. 이용권은 그대로예요. 잠시 뒤 다시 시도해 주세요',
      'error.blocked': '이 내용에는 답할 수 없어요. 이용권은 그대로예요',
      'error.interrupted': '답이 중간에 끊겼어요',
      'error.failed': '대화하지 못했어요. 다시 시도해 주세요',
    });
    ctx.messages('en', {
      label: 'Chat',
      balance: 'Credits left',
      prompt: 'Message',
      send: 'Send',
      stop: 'Stop',
      'error.login_required': 'You were signed out. Please sign in again',
      'error.credits_exhausted': 'You are out of credits. Buy more to get some',
      'error.credits_exhausted_ad': 'You are out of credits. Buy more or watch an ad to get some',
      'error.bad_request': 'That message cannot be sent. Please check it',
      'error.unavailable': 'Chat is unavailable right now. Your credit is unchanged. Please try again shortly',
      'error.blocked': 'This cannot be answered. Your credit is unchanged',
      'error.interrupted': 'The answer was cut off',
      'error.failed': 'Could not chat. Please try again',
    });
    if (params.widget) ctx.slot('home.main', chatWidget(params), { priority: 40 });
  },
});
